export enum SocialNetWorkThreadStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PUBLISHED_APPROVED = 'PUBLISHED_APPROVED',
}
